// CardComponent.js
import React from "react";
import styled from "styled-components";

const Card = styled.div`
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.15);
  }
`;

const Logo = styled.img`
  width: 90px;
  height: 90px;
  border-radius: 50%;
  margin-bottom: 20px;
  object-fit: cover;
`;

const Name = styled.h2`
  font-size: 1.6rem;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
`;

const Address = styled.p`
  color: #777;
  font-size: 1rem;
  margin-bottom: 12px;
`;

const Rating = styled.div`
  font-size: 1.3rem;
  color: #ffc107;
  margin-bottom: 10px;
`;

const Contact = styled.p`
  color: #0066ff;
  margin-bottom: 5px;
  font-size: 1.1rem;
`;

const SocialMedia = styled.div`
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 12px;

  a {
    color: #0066ff;
    font-size: 1.4rem;
    transition: color 0.3s ease;

    &:hover {
      color: #004bb5;
    }
  }
`;

const CardComponent = ({ company, onClick }) => {
  return (
    <Card onClick={onClick}>
      <Logo src={company.logo} alt={`Logo de ${company.nome}`} />
      <Name>{company.nome}</Name>
      <Address>{company.endereco}</Address>
      <Rating>⭐ {company.avaliacao}</Rating>
      <Contact>Contato: {company.contato}</Contact>
      <SocialMedia>
        {company.redesocial.map((link, idx) => (
          <a
            key={idx}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.nome}
          </a>
        ))}
      </SocialMedia>
    </Card>
  );
};

export default CardComponent;
